import { styled } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';

export const SummaryTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.grey[700],
    color: theme.palette.grey[700]
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    WebkitTextFillColor: theme.palette.grey[700],
    color: theme.palette.grey[700]
  }
}));
